import styled from 'styled-components';

const BlogSideBarWrapper = styled.div`
  .search-box {
    position: relative;
    display: flex;
    input {
      flex-basis: 100%;
      padding: 15px 45px 15px 15px;
      border: none;
      border-radius: 5px;
      background: -moz-linear-gradient(45deg, #f3676d 0%, #fda44e 50%, #fda44e 51%, #fec945 100%);
      background: -webkit-linear-gradient(45deg, #f3676d 0%, #fda44e 50%, #fda44e 51%, #fec945 100%);
      background: linear-gradient(45deg, #f3676d 0%, #fda44e 50%, #fda44e 51%, #fec945 100%);
      -webkit-filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f3676d',endColorstr='#fec945',GradientType=1 );
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f3676d',endColorstr='#fec945',GradientType=1 );
      color: ${(props) => props.theme.white};
      &:focus {
        border-color: ${(props) => props.theme.primaryColor};
      }
    }
    button {
      position: absolute;
      right: 0px;
      top: 0;
      height: 100%;
      width: auto;
      padding: 0;
      min-width: 64px;
      border-radius: 5px;
      background: transparent;
      font-size: 22px;
      color: ${(props) => props.theme.white};
      line-height: 40px;
    }
  }
  .sidebar-widgets {
    padding: 0 30px;
  }
  .widgets-title {
    margin-bottom: 20px;
    h3 {
      display: inline-block;
      font-size: 21px;
      font-weight: 500;
      line-height: 30px;
      position: relative;
      &:before {
        position: absolute;
        top: 50%;
        right: -80px;
        content: '';
        width: 70px;
        height: 1px;
      }
    }
  }
  .recent-post-block {
    display: flex;
    align-items: center;
    padding: 10px;
    border: 1px solid rgba(253, 164, 78, 0.3);
    border-radius: 9px;
    & + .recent-post-block {
      margin-top: 30px;
    }
    img {
      margin-right: 20px;
      height: 80px;
      width: 80px;
      border-radius: 5px;
    }
    a {
      h3 {
        font-size: 16px;
        font-weight: 400;
        color: ${(props) => props.theme.textColor};
        margin: 0;
        margin-bottom: 8px;
        transition: all 0.3s ease-in;
        &:hover {
          color: ${(props) => props.theme.primaryColor};
        }
      }
    }
    .post-meta-block {
      margin-bottom: 0;
      font-size: 14px;
      color: ${(props) => props.theme.textColor};
      a {
        font: 400 13px/20px 'Poppins', sans-serif;
        color: ${(props) => props.theme.textColor};
        &:hover {
          color: ${(props) => props.theme.primaryColor};
        }
      }
      a + a {
        position: relative;
        &:before {
          content: '/';
          display: inline-block;
          margin: 0px 5px 0px 0px;
        }
      }
    }
  }

  .sidebar-widgets {
    & + .sidebar-widgets {
      margin-top: 52px;
    }
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
    }
    &.category {
      li {
        & + li {
          margin-top: 3px;
        }
        a {
          color: ${(props) => props.theme.textColor};
          display: flex;
          line-height: 25px;
          justify-content: space-between;
          font: 400 16px/35px 'Poppins', sans-serif;
          em {
            font-style: normal;
            margin: 0;
          }
          span {
            margin: 0;
            border-bottom: 1px solid transparent;
            transition: all 0.3s linear;
          }
          &:hover {
            text-decoration: none;
            span,
            em {
              color: ${(props) => props.theme.primaryColor};
              border-color: ${(props) => props.theme.primaryColor};
            }
          }
        }
      }
    }
    &.tags {
      ul {
        margin-top: -5px;
        margin-left: -5px;
        margin-right: -5px;
      }
      li {
        display: inline-block;
        a {
          margin: 5px;
          display: block;
          padding: 6px 18px;
          border-radius: 24px;
          color: ${(props) => props.theme.white};
          background: ${(props) => props.theme.secondaryColor};
          font: 400 13px/26px 'Poppins', sans-serif;
          transition: all 0.3s linear;
          &:hover {
            color: ${(props) => props.theme.white};
            background: ${(props) => props.theme.primaryColor};
            text-decoration: none;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 1024px) {
    .sidebar-widgets {
      padding: 0;
    }
  }
`;

export default BlogSideBarWrapper;
